var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-countdown"},[_vm._t("default",[_vm._v("\n\t\t"+_vm._s(_vm.formattedTimeRemaaining)+"\n\t")],{"props":{ time: _vm.formattedTimeRemaaining }})],2)}
var staticRenderFns = []

export { render, staticRenderFns }